<div class="permissions-container">
  <mat-card class="permissions-content">
    <mat-card-header>
      <h4>
        {{ 'Manage Permissions' | translate}}
      </h4>
    </mat-card-header>
    <mat-card-content>
      <form [formGroup]="permissionsForm">

        <h4>
          {{'Role' | translate}}
        </h4>
        <mat-radio-group formControlName="role" (change)="onRoleChanged()">
          <mat-list class="list" id="rolesList">
            @for (role of roles; track role) {
              <mat-list-item
                [class.active]="permissionsForm.get('role').value === role.id">
                <mat-radio-button disableRipple="true" [value]="role.id" class="radio">
                  {{role.name}}
                </mat-radio-button>
              </mat-list-item>
            }
          </mat-list>
        </mat-radio-group>

        @if (roleSelected) {
          <ng-container [formGroup]="searchFormGroup" >
            <mat-form-field class="flex-form">
              <input [matAutocomplete]="autoSearch"
                formControlName="searchKey"
                id="searchKey"
                matInput
                placeholder="{{'Search permission' | translate}} " type="text">
            </mat-form-field>
          </ng-container>
          <mat-autocomplete #autoSearch="matAutocomplete" [displayWith]="displayPermissionName">
            <ng-container >
              @for (group of filteredGroupedPermissionsArray; track group) {
                <mat-optgroup [label]="group['key']" (click)="onGroupSelected(group)">
                  @for (permission of group.items; track permission) {
                    <mat-option [value]="permission.permissionRight" (click)="onPermissionSelected(permission)">
                      {{permission.permissionRight }}
                    </mat-option>
                  }
                </mat-optgroup>
              }
            </ng-container>
          </mat-autocomplete>
          <h4>
            {{'Module' | translate}}
          </h4>
          <mat-radio-group formControlName="module" (change)="onModuleChanged()">
            <mat-list class="list" id="modulesList">
              @for (module of modulesList; track module) {
                <mat-list-item #amodule
                  [class.active]="permissionsForm.get('module').value === module">
                  <mat-radio-button disableRipple="true" [value]="module" class="radio">
                    {{module}}
                  </mat-radio-button>
                </mat-list-item>
              }
            </mat-list>
          </mat-radio-group>
          <div class="even-columns">
            <button mat-button
              [disabled]="!roleAndModuleSelected"
            (click)="selectAllPermissions(true)">{{'Select All' | translate}}</button>
            <button mat-button
              [disabled]="!roleAndModuleSelected"
            (click)="selectAllPermissions(false)">{{'Deselect All' | translate}}</button>
          </div>
          <div class="sliders-group">
            @for (l of permissionsForm.get('permissions')?.controls; track l; let i = $index) {
              <div formArrayName="permissions">
                <mat-slide-toggle [formControlName]="i">
                  {{ filteredPermissionsArray[i]?.permissionRight }}
                </mat-slide-toggle>
              </div>
            }
          </div>
        }

      </form>
    </mat-card-content>
    <mat-card-actions class="actions" align="end">
      <button mat-flat-button color="primary" class="primary" [disabled]="!roleAndModuleSelected"
      (click)="updatePermissions()">{{ 'Save' | translate}}</button>
    </mat-card-actions>
  </mat-card>
</div>
